var BaseViews = require('../base');
require('./sidebar-modal/sidebar-modal.scss');
var ActiveOrders = require('../orders/active-orders.js');
var SidebarModal = BaseViews.LayoutView.extend({
    className: 'fmcy-sidebar-modal fmcy-plugin-bootstrap',
    template: require('./sidebar-modal/sidebar-modal.html'),
    initialize: function(options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                theme: 'dark',
                isUserLoggedIn: false,
                customerData: null,
                _appChannel: null
            }
        );
    },
    ui: {
      loginButton: '.login-button',
      joinButton: '.register-button',
      displayName: '.display-name',
      sideBarMenuWrapper: '.fmcy-side-bar-menu-wrapper',
      sideBarLeftArea:'.fmcy-side-bar-menu-left-area'
    },
    events : {
      'click @ui.loginButton': 'loginButtonClicked',
      'click @ui.joinButton': 'joinButtonClicked'
    },
    joinButtonClicked: function () {
      this.options._appChannel.trigger('menu:sidebar:view');
      this.options._appChannel.trigger('show:register:dialog');
    },
    loginButtonClicked: function () {
      this.options._appChannel.trigger('menu:sidebar:view');
      this.options._appChannel.trigger('show:login:dialog');
    },
    regions: {
        myOrdersRegion: '.fmcy-customer-my-orders-region',
    },
    _renderActiveOrders: function () {
      this._activeOrders = new ActiveOrders({
        collection: this.options._appChannel.request('customer:get:data').get('orders'),
        _appChannel: this.options._appChannel
      });
      this.myOrdersRegion.show(this._activeOrders);
    },
    _onWindowResize: function (event) {
      if ($(window).width() > 1100) {
        var rightPos = (($(window).width() - 1100) / 2);
        this.ui.sideBarMenuWrapper.css('right', rightPos);
      } else {
        this.ui.sideBarMenuWrapper.css('right', 0);
        this.ui.sideBarLeftArea.width($(window).width());
      }
    },
    serializeData: function () {
      var displayName = null;

      if (this.options.customerData !== null) {
        displayName = this.options.customerData.get('first_name');
        this.options.customerData.on('change:is_club_member', function () {
          // show badge....
        });
      }

      return {
        rootUrl: window.location.protocol + '//' + window.location.hostname,
        isUserLoggedIn: this.options.isUserLoggedIn,
        displayName: displayName
      }
    },
    onRender: function() {
      var self = this;
      if (this.options.isUserLoggedIn == true) {
        this._renderActiveOrders();
      }
      this._onWindowResize();
      $(window).on('resize.' + this.cid, _.bind(this._onWindowResize, this));

      this.listenTo(this.options._appChannel, 'orders:updated', function () {
        self._renderActiveOrders();
      });

      if (this.options.isUserLoggedIn == true && this.options.customerData) {
        this.listenTo(this.options.customerData, 'change:display_name', function () {
          self.ui.displayName.html(displayName);
        });
      }

      BaseViews.LayoutView.prototype.onRender.call(self);
    },
    onDestroy: function () {
      $(window).off('resize.' + this.cid);
      BaseViews.LayoutView.prototype.onDestroy.call(self);
    }
});

module.exports = SidebarModal;



/** WEBPACK FOOTER **
 ** ./assets/js/common/sidebar/sidebar-modal.js
 **/